import "bootstrap/js/dist/tooltip";
import "./selectator/fm.selectator.jquery";
import {translate} from "./language";


if (!$.fn.tooltip) {
    throw new Error('Bootstrap Tooltip must be included first!');
}

var Tooltip = $.fn.tooltip.Constructor;

$.extend(Tooltip.Default, {
    customClass: ''
});

var _show = Tooltip.prototype.show;

Tooltip.prototype.show = function () {

    _show.apply(this);

    if (this.config.customClass) {
        var tip = this.getTipElement();
        $(tip).addClass(this.config.customClass);
    }

};

$.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    }
    return decodeURI(results[1]) || 0;
};

export const echo = (obj, label) => {
    if (typeof(console) == "undefined") return;
    if (typeof(console.log) == "undefined") return;
    if (typeof(label) == "undefined") {
        console.log(obj);
    } else {
        console.log(label, obj);
    }
}

export const runAfterAjax = () => {
    frontendAndBackendFunctions();
    initLightBox();
}

export const initLightBox = () => {
    if(typeof fsLightboxInstances != 'undefined') {
        for (const instance in fsLightboxInstances) {
            if (fsLightboxInstances.hasOwnProperty(instance)) {
                if(instance !== 'photogallery') {
                    fsLightboxInstances[instance].props.showThumbsOnMount = true;
                }
            }
        }
    }
    if(typeof refreshFsLightbox === "function") {
        refreshFsLightbox();
    }
}

export const startStars = () => {
    const stars = $('.star-readonly');
    if(stars.length && $.isFunction($.fn.rating)) {
        stars.rating({
            readOnly: true
        });
    }
}

export const frontendAndBackendFunctions = () => {
    // hezke selekty
    const selects = $('select:visible:not(.js-custom-select)');
    if(selects.length){
        selects.each(function () {
            const settings = {
                useSearch: $(this).find('option').length > 7,
                labels: {
                    search: translate('Vyhledat') + '...'
                }
            };

            $(this).selectator(settings);
        });
    }
    const titles = $("[title]").not(".mce-panel, .notooltip, #addvalue-text_ifr, .mce-container, .mce-btn, .ribbonLockGlobal, .ribbonLock");
    if(titles.length) {
        titles.attr('data-toggle', 'tooltip');
    }
    const body = $("body");
    body.tooltip({
        selector: '[data-toggle="tooltip"]:not(.c-size-item)',
    });
    $('.c-size-item').tooltip({
        html: true,
        placement: 'bottom',
        template: '<div class="tooltip c-size-item__tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
    });
    startStars();
}

export const cisSelectator = (selector) => {
    return $('[data-jquery='+selector+']');
}

export const nicePrice = (price) => {
    return number_format(price, 0, '.', ' ') + ',-';
}

export const number_format = (number, decimals, dec_point, thousands_sep) => {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    const n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    let s = '';
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}